import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section 
        className="relative py-32 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBvZmZpY2V8ZW58MHx8fHwxNzcyMjcwNjc2fDA&ixlib=rb-4.1.0&q=85)'
        }}
      >
        <div className="absolute inset-0 bg-slate-900/80"></div>
        <div className="container mx-auto px-6 relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold text-white text-center mb-6">
            About <span className="text-[#FF9900]">EYME LLC</span>
          </h1>
          <p className="text-xl text-gray-200 text-center max-w-3xl mx-auto">
            Your strategic e-commerce growth partner
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-4xl font-bold text-slate-900 mb-8">
                Founded as a <span className="text-[#FF9900]">Strategic E-Commerce Growth Partner</span>
              </h2>
              
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                EYME LLC was established with a clear vision: to simplify and elevate the Amazon selling 
                experience for manufacturers, distributors, and brand owners. What started as a mission 
                to bridge the gap between quality products and global marketplaces has evolved into a 
                comprehensive e-commerce powerhouse.
              </p>

              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Today, we proudly support over 2,000 vendors, helping them navigate the complexities of 
                online retail with data-driven marketplace solutions. Our approach combines cutting-edge 
                technology with personalized service, ensuring that every partner receives the attention 
                and expertise they deserve.
              </p>

              <p className="text-gray-700 text-lg leading-relaxed mb-8">
                At EYME LLC, we don't just manage sales—we build lasting partnerships. Our commitment to 
                transparency, scalability, and long-term growth has made us a trusted name in the e-commerce 
                industry. We invest in your success because when you grow, we grow.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
                <Card className="border-0 shadow-lg bg-slate-50">
                  <CardContent className="p-8 text-center">
                    <div className="text-5xl font-bold text-[#FF9900] mb-2">2000+</div>
                    <div className="text-gray-700 font-semibold">Vendors Supported</div>
                  </CardContent>
                </Card>
                <Card className="border-0 shadow-lg bg-slate-50">
                  <CardContent className="p-8 text-center">
                    <div className="text-5xl font-bold text-[#FF9900] mb-2">$45M+</div>
                    <div className="text-gray-700 font-semibold">Annual Revenue</div>
                  </CardContent>
                </Card>
                <Card className="border-0 shadow-lg bg-slate-50">
                  <CardContent className="p-8 text-center">
                    <div className="text-5xl font-bold text-[#FF9900] mb-2">100%</div>
                    <div className="text-gray-700 font-semibold">Client Satisfaction</div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-slate-900 mb-8 text-center">
              Our <span className="text-[#FF9900]">Mission</span>
            </h2>
            <p className="text-gray-700 text-lg leading-relaxed text-center mb-6">
              To empower brands with the tools, strategies, and support they need to thrive in the 
              competitive world of e-commerce. We believe in making Amazon selling accessible, 
              profitable, and sustainable for businesses of all sizes.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-slate-900 mb-12 text-center">
            Our <span className="text-[#FF9900]">Values</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Transparency</h3>
                <p className="text-gray-600 leading-relaxed">
                  We believe in open communication and honest reporting. You always know where 
                  your products stand and how your investment is performing.
                </p>
              </CardContent>
            </Card>
            <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Scalability</h3>
                <p className="text-gray-600 leading-relaxed">
                  Our infrastructure and expertise are designed to grow with you, from your first 
                  product listing to managing a complete catalog.
                </p>
              </CardContent>
            </Card>
            <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Partnership</h3>
                <p className="text-gray-600 leading-relaxed">
                  We view every client relationship as a long-term partnership. Your success is 
                  our success, and we're committed to supporting you every step of the way.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
